import React, { useEffect, useRef } from 'react';
import "./YoutubeSection.css";

// Import YouTube thumbnail images
import youtubeImage1 from "../../assets/youtube-learn-css-variables.png";
import youtubeImage2 from "../../assets/youtube-master-css-flexbox.png";
import youtubeImage3 from "../../assets/youtube-push-your-code-to-github.png";

const YoutubeSection = () => {
    const sectionRef = useRef(null);

    // YouTube video data - replace with your actual video links
    const youtubeVideos = [
        {
            id: 1,
            title: "Master CSS Flexbox (Complete Beginner Guide)",
            thumbnail: youtubeImage2,
            videoUrl: "https://www.youtube.com/watch?v=LdCouVeIRZg",
            description: "Transform your layouts with CSS Flexbox in just 11 minutes! Stop struggling with CSS positioning and finally understand how to create responsive, flexible layouts that actually work! This comprehensive tutorial will take you from complete beginner to Flexbox master in under 12 minutes." },
        {
            id: 2,
            title: "Push Your Code to GitHub in 5 Minutes!",
            thumbnail: youtubeImage3,
            videoUrl: "https://www.youtube.com/watch?v=Z5sgw6PJkn8",
            description: "Learn to push your code to GitHub in just 5 minutes! Stop struggling with Git commands and finally get your projects online! This quick tutorial will teach you everything you need to know to push your first repository to GitHub."
        },
        {
            id: 3,
            title: "Learn CSS VARIABLE in 6mins",
            thumbnail: youtubeImage1,
            videoUrl: "https://www.youtube.com/watch?v=JoIUnBarUkY",
            description: "Master one of the most powerful features of modern CSS that will revolutionize how you write and maintain your stylesheets."
        }
    ];

    // Scroll-triggered animation using Intersection Observer
    useEffect(() => {
        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        // Add animation class when section comes into view
                        entry.target.classList.add('animate');
                        
                        // Optional: Stop observing after animation is triggered
                        // observer.unobserve(entry.target);
                    }
                });
            },
            {
                threshold: 0.3, // Trigger when 30% of the section is visible
                rootMargin: '0px 0px -100px 0px' // Start animation slightly before section is fully in view
            }
        );

        if (sectionRef.current) {
            observer.observe(sectionRef.current);
        }

        // Cleanup observer on component unmount
        return () => {
            if (sectionRef.current) {
                observer.unobserve(sectionRef.current);
            }
        };
    }, []);

    const handleVideoClick = (videoUrl) => {
        window.open(videoUrl, '_blank');
    };

    const handleYoutubePageClick = () => {
        // Replace with your actual YouTube channel URL
        window.open('https://www.youtube.com/@cholantechsolutions', '_blank');
    };

    return (
        <div className='youtube_section_container' ref={sectionRef}>
            <div className="youtube_section_header">
                <h2>Latest Videos</h2>
                <p>Check out my latest content on YouTube</p>
            </div>
            
            <div className="youtube_videos_grid">
                {youtubeVideos.map((video) => (
                    <div 
                        key={video.id} 
                        className="youtube_video_card"
                        onClick={() => handleVideoClick(video.videoUrl)}
                    >
                        <div className="video_thumbnail">
                            <img src={video.thumbnail} alt={video.title} />
                            <div className="play_button_overlay">
                                <div className="play_icon">▶</div>
                            </div>
                        </div>
                        <div className="video_info">
                            <h3>{video.title}</h3>
                            <p>{video.description}</p>
                        </div>
                    </div>
                ))}
            </div>
            
            <div className="youtube_cta_section">
                <button 
                    className="youtube_page_btn"
                    onClick={handleYoutubePageClick}
                >
                    Visit My YouTube Channel
                </button>
            </div>
        </div>
    );
};

export default YoutubeSection;
